import "../scss/style.scss";

import domReady from "./core/dom-ready";
import "./core/jquery-global";
import { loadLegacyVendors } from "./core/vendor-loader";

import { initWow } from "./modules/wow-init";
import { initPageLoader } from "./modules/page-loader";
import { initNavigation } from "./modules/navigation";
import { initScrollTop } from "./modules/scroll-top";
import { initAnimations } from "./modules/animations";
import { initSliders } from "./modules/sliders";

(async function bootstrap() {
    const { Waypoint, CountUp } = await loadLegacyVendors();

    domReady(function () {
        initWow();
        initPageLoader();
        initNavigation();
        initScrollTop();
        initAnimations({ Waypoint, CountUp });
        initSliders();
    });
})();
